import React, { useRef, useState } from "react";
import styles from "../../styles/components/breakdownAnalyticsTable.module.scss";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import EyeTableIcon from "../../public/assets/icons/EyeTableIcon";
import ModalWrappperLargeOpacity from "../../ui/ModalWrapper/ModalWrapperLargeOpacity";
import PaymentDone from "../../public/assets/images/payment_done.svg";
import DownloadBlueIcon from "../../public/assets/icons/DownloadBlueIcon";
import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";
import PaymentDoneSign from "../../public/assets/icons/PaymentDoneSign";
import MultiplicationSign from "../../public/assets/icons/MultiplicationSign";
import EqualToSign from "../../public/assets/icons/EqualToSign";
import { usePost } from "../../hooks/api/useFetch";
import ApiLoader from "../Loaders/ApiLoader";
import { getUtcDate } from "../../lib/functions/utils.lib";

// function createData(month, amount, payment_status, details) {
//   return { month, amount, payment_status, details };
// }

// const rows = [
//   createData("January", "$1025", "Completed"),
//   createData("February", "$1025", "Completed"),
//   createData("March", "$1025", "Completed"),
//   createData("April", "$1025", "Completed"),
//   createData("May", "$1025", "Completed"),
//   createData("June", "$1025", "Completed"),
// ];

const BreakdownAnalyticsTableLeft = ({
  expenseData,
  expenseLoading,
  expenseSubmissionsIsSuccess,
  approved,
}) => {
  const [modalMonth, setModalMonth] = useState(1);
  const [monthValueIs, setMonthValueIs] = useState(null);

  console.warn(modalMonth);
  const [openModal, setopenModal] = useState(false);

  console.warn("expenDate is ", expenseData);

  const handleopen = (value) => {
    setopenModal(true);
    setMonthValueIs(value);
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const indexOFMonth = months.indexOf(value) + 1;
    setModalMonth(indexOFMonth);
  };

  const handleClose = () => {
    setopenModal(false);
    setModalMonth("");
  };

  // analytics
  const {
    data: expenseDataValue,
    isLoading: Loading,
    isSuccess: IsSuccess,
    isFetching: Fetching,
  } = usePost(
    ["manager-partner-Data", modalMonth],
    "member_partner/detail-expense-breakdown",
    {
      month: modalMonth && modalMonth,
    }
  );
  console.warn("expenseDataValue is ", expenseDataValue);

  const salary = parseFloat(
    expenseDataValue?.data[0]?.rate_per_video === "0" &&
      parseFloat(expenseDataValue?.data[0]?.flat_rate)
  );
  const Current_earnings = parseFloat(
    expenseDataValue?.data[0]?.rate_per_video * approved
  );

  // bonus
  const bonus = parseFloat(
    expenseDataValue?.data[0]?.earnings[0]?.bonus
      ? expenseDataValue?.data[0]?.earnings[0]?.bonus
      : 0
  );

  const total = parseFloat(salary ? salary : Current_earnings) + bonus;

  // analytics

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const date = new Date();
  const dateIndex = date.getMonth() + 1;

  const currentMonth = (month) => {
    const index = months.indexOf(month);
    return index + 1;
  };

  return (
    <Box className={styles.tableMain}>
      <TableContainer component={Paper}>
        <PerfectScrollbar className={styles.tableScroll}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell className={styles.month}>Month</TableCell>
                <TableCell className={styles.amount} align="left">
                  Amount
                </TableCell>
                <TableCell className={styles.payment_status} align="left">
                  Payment Status
                </TableCell>
                <TableCell className={styles.details} align="center">
                  Details
                </TableCell>
              </TableRow>
            </TableHead>
            {expenseData?.data.length && (
              <TableBody>
                {expenseData?.data?.slice(0, 6).map((row) => (
                  <TableRow
                    key={row.month}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell>{row.month}</TableCell>
                    <TableCell>$ {row.count}</TableCell>
                    <TableCell>
                      {" "}
                      {dateIndex === currentMonth(row?.month)
                        ? "Pending"
                        : dateIndex < currentMonth(row?.month)
                        ? "_"
                        : "Completed"}
                    </TableCell>
                    <TableCell align="center" className={styles.eyeBtnWrapper}>
                      <Button
                        className={styles.eyeBtn}
                        onClick={() => handleopen(row?.month)}
                      >
                        {dateIndex < currentMonth(row?.month) ? (
                          ""
                        ) : (
                          <EyeTableIcon color={"#5F5F5F"} />
                        )}
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}
          </Table>
        </PerfectScrollbar>
      </TableContainer>

      <ModalWrappperLargeOpacity
        open={openModal}
        onClose={handleClose}
        handleClose={handleClose}
        title={"Earnings Breakdown"}
        classModal={"analyticsModal"}
      >
        <PerfectScrollbar>
          <ApiLoader loading={Loading} />
          <Box className={styles.earningModalWrapper}>
            <Box className={styles.modaltop}>
              <Typography variant="body1">
                {monthValueIs} 2023{" "}
                <Typography variant="caption">
                  <span style={{ color: "blue" }}>Today</span>(
                  {getUtcDate(date)})
                </Typography>
              </Typography>
              <Button
                className={`${styles.topBtn} ${styles.fadedText}`}
                startIcon={<DownloadBlueIcon />}
              >
                Download report
              </Button>
            </Box>
            <Box className={styles.accordianWrapper}>
              <Accordion>
                <AccordionSummary
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={styles.accordian_header}
                >
                  <Box className={styles.openHeading}>
                    <Typography>Salary</Typography>
                    <Typography>${salary}</Typography>
                  </Box>
                  <Box className={styles.closeHeading}>
                    {expenseDataValue?.data[0]?.rate_per_video &&
                    expenseDataValue?.data[0]?.rate_per_video === "0" ? (
                      <>
                        {" "}
                        <Typography variant="body1">Salary</Typography>
                        <Box className={styles.signWrapper}>
                          <Typography variant="body1"> {salary}</Typography>{" "}
                          {expenseDataValue?.data[0]?.flat_rate === "0" && (
                            <MultiplicationSign />
                          )}{" "}
                        </Box>
                      </>
                    ) : (
                      <>
                        {" "}
                        <Typography variant="body1">
                          Fee per approved Submission:
                        </Typography>
                        <Box className={styles.signWrapper}>
                          <Typography variant="body1">
                            {expenseDataValue?.data[0]?.rate_per_video &&
                              expenseDataValue?.data[0]?.rate_per_video}
                          </Typography>{" "}
                          {expenseDataValue?.data[0]?.flat_rate === "0" && (
                            <MultiplicationSign />
                          )}{" "}
                        </Box>
                      </>
                    )}
                  </Box>
                </AccordionSummary>
                <AccordionDetails className={styles.salaryAccordian}>
                  <List>
                    <ListItem>
                      <Typography variant="body1">
                        Number of approved Submissions:
                      </Typography>
                      <Box className={styles.signWrapper}>
                        <Typography variant="body1">
                          {approved && approved}
                        </Typography>{" "}
                        {expenseDataValue?.data[0]?.flat_rate === "0" && (
                          <EqualToSign />
                        )}{" "}
                      </Box>
                    </ListItem>
                    {expenseDataValue?.data[0]?.flat_rate === "0" && (
                      <ListItem>
                        <Typography variant="body1">
                          Current earnings:
                        </Typography>
                        <Typography variant="body1">
                          ${Current_earnings}
                        </Typography>
                      </ListItem>
                    )}{" "}
                  </List>
                </AccordionDetails>
              </Accordion>
            </Box>
            <Box className={styles.outstanding_box}>
              <List>
                <ListItem>
                  <Typography variant="body1">Salary:</Typography>
                  <Typography variant="body1">
                    ${salary ? salary : Current_earnings}
                  </Typography>
                </ListItem>
                <ListItem>
                  <Typography variant="body1">Bonus:</Typography>
                  <Typography variant="body1">$ {bonus && bonus}</Typography>
                </ListItem>
                <ListItem>
                  <Typography variant="body1">Payable Amount:</Typography>
                  <Typography variant="body1">${total}</Typography>
                </ListItem>
              </List>
            </Box>
            <Box className={styles.payment_successful}>
              <PaymentDoneSign />
              <Typography>Payment completed on: February 7, 2023</Typography>
            </Box>
          </Box>
        </PerfectScrollbar>
      </ModalWrappperLargeOpacity>
    </Box>
  );
};

export default BreakdownAnalyticsTableLeft;
